import { useLocalePathPrefix } from '../getWebsiteUrl'

const locale = process.env.GATSBY_INTL_LOCALE

export const removeLocaleFromPathname = (pathname) => {
  if (!useLocalePathPrefix) return pathname
  return pathname.replace(`/${locale}/`, '/')
}

export const removeDuplicateLocaleFromPathname = (pathname = '') => {
  if (!useLocalePathPrefix) return pathname
  return pathname?.replace(`/${locale}/${locale}/`, `/${locale}/`)
}
